export default __webpack_public_path__ + "static/media/table-convert.3b16ad91.svg";